import * as Types from './types';

import gql from 'graphql-tag';
import { BettorFragmentDoc } from './fragments/bettor';
export type BettorsQueryVariables = Types.Exact<{
  where: Types.Bettor_Filter;
}>;


export type BettorsQuery = { __typename?: 'Query', bettors: Array<{ __typename?: 'Bettor', id: string, rawToPayout: string, rawInBets: string, rawTotalPayout: string, rawTotalProfit: string, betsCount: number, wonBetsCount: number, lostBetsCount: number }> };


export const BettorsDocument = gql`
    query Bettors($where: Bettor_filter!) {
  bettors(where: $where, subgraphError: allow) {
    ...Bettor
  }
}
    ${BettorFragmentDoc}`;